import resources from '../translations/resources';
import { getResourceLocale } from '../helpers';

// The translations tree is keyed by underscore *resource* locales (`es_MX`,
// `fr_CA`, `en_XL`). `i18next.language` is the short/hyphenated code fed to
// `i18n.setLocale()` (e.g. `es`, `es-MX`), which `getResourceLocale` can't map
// to those keys on its own. Resolve it the same way the dispatch sites do
// (useSupportedLanguages.ts, initializeTranslations.ts) so regional keys
// resolve and unsupported locales fall back to English (`i18n.defaultLocale`).
// i18next normalizes underscore region codes to hyphens (`es_MX` -> `es-MX`),
// but the resource tree is keyed by underscore. `getResourceLocale` only
// builds the `${locale}_${country}` form for 2-char locales, so a 5-char
// hyphenated `es-MX` would be looked up raw (missing), then sliced to the base
// `es` -- dropping regional keys for returning users whose init cookie is a
// regional locale. Convert back to underscore so the 5-char form matches the
// resource key directly; a 2-char locale (`es`) is unaffected, keeping the
// existing 2-char + cookie-country path intact.
export const resolveLocale = (language: string | undefined): string =>
  getResourceLocale(resources(), language?.replace('-', '_'));
